import React from "react";
import { FaEnvelope } from "react-icons/fa";
import { Card } from "../UI/DesignStandards";

const EmailDisplay = ({ email }) => {
  return (
    <Card className="mb-0" aria-labelledby="email-heading">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div
            className="w-10 h-10 bg-brand-cream rounded-lg flex items-center justify-center"
            aria-hidden="true"
          >
            <FaEnvelope className="h-5 w-5 text-brand-muted" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h3
              id="email-heading"
              className="heading-display text-lg"
            >
              Email
            </h3>
            <span className="inline-flex items-center bg-brand-charcoal text-brand-cream px-2 py-1 rounded-lg text-xs font-display font-bold">
              Verified
            </span>
          </div>
          <p
            className="text-brand-charcoal break-all"
            aria-label={`Email address: ${email}`}
          >
            {email}
          </p>
        </div>
      </div>
    </Card>
  );
};

export default EmailDisplay;
